import { stringifyEntityRef } from '@backstage/catalog-model';
import React from 'react';
import { useStarredEntity } from '../../hooks/useStarredEntity.esm.js';
import { catalogReactTranslationRef } from '../../translation.esm.js';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { FavoriteToggle } from '@backstage/core-components';

const FavoriteEntity = (props) => {
  const { toggleStarredEntity, isStarredEntity } = useStarredEntity(
    props.entity
  );
  const { t } = useTranslationRef(catalogReactTranslationRef);
  const title = isStarredEntity ? t("favoriteEntity.removeFromFavorites") : t("favoriteEntity.addToFavorites");
  const id = `favorite-${stringifyEntityRef(props.entity).replace(
    /[^a-zA-Z0-9-_]/g,
    "-"
  )}`;
  return /* @__PURE__ */ React.createElement(
    FavoriteToggle,
    {
      title,
      id,
      isFavorite: isStarredEntity,
      onToggle: toggleStarredEntity,
      ...props
    }
  );
};

export { FavoriteEntity };
//# sourceMappingURL=FavoriteEntity.esm.js.map
